import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import promptSaga from './leads/saga'
import commsSaga from './comms/saga'
import reportSaga from './reports/saga'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    promptSaga(),
    commsSaga(),
    reportSaga(),
  ]);
}
